import {defineMessages} from 'react-intl';

export default defineMessages({
    allow: {
        id: 'app.pages.consent.large.allow',
        defaultMessage: 'Allow'
    },
    deny: {
        id: 'app.pages.consent.large.deny',
        defaultMessage: 'Deny'
    },
    allowed: {
        id: 'app.pages.consent.large.allowed',
        defaultMessage: 'Allowed'
    },
    denied: {
        id: 'app.pages.consent.large.denied',
        defaultMessage: 'Denied'
    },
    moreInfo: {
        id: 'app.pages.consent.large.moreInfo',
        defaultMessage: 'More info'
    }
});
